import sharedConstants from "@lib/shared_constants";

import type { defaultFeatureFlagDefinitions, defaultFeatureFlagProperties } from "./constants";

/** Options for property value type */
const sdkMessagePropertyTypes = sharedConstants.SDK_MESSAGE_PROPERTIES.TYPES;
export type FeatureFlagPropertyTypes = (typeof sdkMessagePropertyTypes)[keyof typeof sdkMessagePropertyTypes];

export interface FeatureFlagProperty {
  /** Type of the property value */
  type: FeatureFlagPropertyTypes;
  /** Property key */
  key: string;
  /** Default value of the property that can be overridden */
  defaultValue: string;
  /** URL of a newly uploaded image */
  uploadedImageUrl?: string;
}

/** Properties that are serialized for the backend */
export type SerializedFeatureFlagProperties = {
  [key: string]: { type: FeatureFlagPropertyTypes; value: string | {} };
};

/**
 * Used to define the shape of the context that `useFeatureFlag` pulls its data from
 */
export interface FeatureFlagDefinitionShape {
  [FlagId: string]: {
    [key: string]: boolean | number | string;
  };
}

/** Convenience type to use in functions that require an id like `useFeatureFlag` */
export type FeatureFlagIds = keyof typeof defaultFeatureFlagProperties;

/** The type-safe definition of feature flags we support */
export interface FeatureFlag<Flag extends FeatureFlagIds> {
  enabled: boolean;
  properties: Partial<(typeof defaultFeatureFlagProperties)[Flag]>;
}

export type FeatureFlagDefinitions = typeof defaultFeatureFlagDefinitions;
export type FeatureFlagMap = {
  [FlagId in FeatureFlagIds]: {
    enabled: boolean;
    properties: Partial<(typeof defaultFeatureFlagProperties)[FlagId]>;
  };
};
